import clsx from "clsx"
import { useMemo } from "react"
import zxcvbn from "zxcvbn"

import { ProgressBar } from "@atoms"

import styles from "./PasswordStrengthIndicator.module.scss"
import { PasswordStrengthIndicatorProps } from "./PasswordStrengthIndicator.types"

export default function PasswordStrengthIndicator({ password }: PasswordStrengthIndicatorProps) {
    const result = useMemo(() => (password !== "" ? zxcvbn(password) : null), [password])

    const strengthLabels = ["Weak", "Weak", "Average", "Strong", "Excellent"]
    const strengthColors = ["weak", "weak", "average", "strong", "excellent"]
    const score = result?.score ?? -1

    const strengthLabel = score >= 0 ? strengthLabels[score] : "Strength"
    const strengthClass = score >= 0 ? styles[strengthColors[score]] : ""

    const progressMap = [0, 25, 50, 75, 100]
    const progressValue = score >= 0 ? progressMap[score] : 0

    return (
        <div
            className={clsx(styles.base, strengthClass)}
            aria-valuenow={score}
            aria-valuemax={4}
            aria-valuemin={0}
            role="progressbar"
            aria-label={strengthLabel}
        >
            <div className={styles.strength}>{strengthLabel}</div>
            <ProgressBar
                value={progressValue}
                indicatorClassName={styles.indicatorColor}
                className={styles.progressWrapper}
            />
        </div>
    )
}
